<template>
  <page :title="title">
    <v-container fluid grid-list-sm>
        <message :messages="messages"></message>
          <v-layout row wrap align-center>
                  <v-flex xs12 sm12 md12 lg12>
                    <v-expansion-panels v-model="panel" multiple>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <div>
                            <v-icon>mdi-filter-variant</v-icon> Date Range
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                                                    <v-card>
                            <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
            <v-flex xs12 sm6 md6 lg6>
              <cal-picker
                v-model="form.tranDateFrom"
                :label="labels.tranDateFrom"
                :data-vv-as="labels.tranDateFrom"
                data-vv-name="form.tranDateFrom"
                :error-messages="errors.collect('form.tranDateFrom')"
                v-validate="'required'"
              />
            </v-flex>
            <v-flex xs12 sm6 md6 lg6>
              <cal-picker
                v-model="form.tranDateTo"
                :label="labels.tranDateTo"
                :data-vv-as="labels.tranDateTo"
                data-vv-name="form.tranDateTo"
                :error-messages="errors.collect('form.tranDateTo')"
                v-validate="'required'"
              />
            </v-flex>
            <v-flex xs12 class="ma-0 pa-0" />
            <v-flex xs12 sm6 md6 lg6>
              <cal-picker
                v-model="form.glTranDate"
                :label="labels.glTranDate"
                :data-vv-as="labels.glTranDate"
                data-vv-name="form.glTranDate"
                :error-messages="errors.collect('form.glTranDate')"
                v-validate="'required'"
              />
            </v-flex>
                                  </v-layout>
                    </v-container>
                          </v-card-text>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-flex>
            <v-flex xs12 class="ma-0 pa-0" />
                  <v-flex xs12 sm12 md12 lg12  class="mt-3">
                    <v-expansion-panels v-model="panels" multiple>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <div>
                            <v-icon>mdi-filter-variant</v-icon> Selection Criteria
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                                                                              <v-card>
                            <v-card-text>
            <v-flex xs12>
              <v-text-field
                v-model="form.branch"
                :label="labels.branch"
                :error-messages="errors.collect('form.branch')"
                data-vv-name="form.branch"
                :data-vv-as="labels.branch"
                append-icon="mdi-magnify"
                readonly
                @click="showBranchHelpList = true"
                clearable
                v-validate="'required'"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="form.polType"
                :label="labels.polType"
                :error-messages="errors.collect('form.polType')"
                data-vv-name="form.polType"
                :data-vv-as="labels.polType"
                append-icon="mdi-magnify"
                readonly
                @click="showPolTypeHelpList = true"
                clearable
                v-validate="'required'"
              />
            </v-flex>
                                      </v-card-text>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                    </v-flex>
          </v-layout>
          <v-flex class="mt-3"></v-flex>
          <v-flex xs12 sm12 md12 lg12>
            <v-btn color="secondary" @click="doSubmit('print')" class="mr-2">
              {{ labels.print }}
              <v-icon right>mdi-clipboard-check-outline</v-icon>
            </v-btn>
            <v-btn color="primary" @click="doSubmit('post')">
              {{ labels.post }}
              <v-icon right>mdi-clipboard-check</v-icon>
            </v-btn>
          </v-flex>
    </v-container>
    <v-dialog v-model="showBranchHelpList" width="900px" persistent>
      <multi-branch-help-list :brn="form.branch" @close="showBranchHelpList = false" @doAssign="doAssignBranch($event)"></multi-branch-help-list>
    </v-dialog>
    <v-dialog v-model="showPolTypeHelpList" width="900px" persistent>
      <multi-pol-type-help-list
        :pt="form.polType"
        @close="showPolTypeHelpList = false"
        @doAssign="doAssignPolType($event)"
      ></multi-pol-type-help-list>
    </v-dialog>

    <v-dialog v-model="promptExeJob" width="500px" persistent>
      <batch-job-scheduler
        v-if="promptExeJob"
        :skipValidate="batchForm.skipValidate"
        :jobKeys="form"
        :showJobMode="false"
        @close="promptExeJob = false"
        @doPopulate="processBatch($event)"
      />
    </v-dialog>

    <warning v-model="promptResubmit" @ok="doAccept">
      <div>{{ warningMsg1 }}</div>
      <div class="queryValue" v-for="(item, index) in bchJobDetails" :key="index">{{ item }}</div>
      <div>{{ warningMsg2 }}</div>
    </warning>
  </page>
</template>

<script>
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList.vue'
import MultiPolTypeHelpList from '@/components/core/common/dialog/MultiPolTypeHelpList'
import MessageMixin from '@/mixins/message'
import BatchJobScheduler from '@/components/core/common/BatchJobScheduler'
import { batchManagerMixin } from '@/mixins/common/batchManagerMixin'
export default {
  data() {
    return {
      title: 'Post Outstanding Claims Reserves',
      showBranchHelpList: false,
      showPolTypeHelpList: false,
      form: {
        action: undefined,
        tranDateFrom: new Date(),
        tranDateTo: new Date(),
        glTranDate: new Date(),
        branch: 'All',
        polType: 'All'
      },
      labels: {
        tranDateFrom: 'Claim Transaction Date From*',
        tranDateTo: 'Claim Transaction Date To*',
        glTranDate: 'GL Transaction Date*',
        branch: 'Branch',
        polType: 'Policy Type',
        print: 'Print Checklist',
        post: 'Post to Accounts'
      },
      panel: [0],
      panels: [0]
    }
  },
  components: {
    MultiBranchHelpList,
    MultiPolTypeHelpList,
    BatchJobScheduler
  },
  mixins: [MessageMixin, batchManagerMixin],
  computed: {
    osClmRes() {
      return this.$store.state.osClmRes
    },
    menu() {
      return this.osClmRes.menu
    }
  },
  methods: {
    async doAssignBranch(Obj) {
      this.form.branch = ''
      this.form.branch = Obj.finalSelectedItems.toString()
      this.$validator.validate('form.branch')
    },
    async doAssignPolType(Obj) {
      this.form.polType = []
      this.form.polType = Obj.finalSelectedItems.toString()
      this.$validator.validate('form.polType')
    },
    doSubmit(action) {
      this.form.action = action
      this.validateForm()
    },
    async validateForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.isBatchManager === true) {
            this.promptExeJob = true
          } else {
            this.sendRequest()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async sendRequest() {
      const apiURI = this.menu.processOSClmRes
      if (apiURI) {
        try {
          this.submitting = true
          const result = await this.$http.post(apiURI, this.form)
          if (result.data) {
            this.$toast.success('Job successfully submitted to batch job process.')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async processBatch(bmgForms) {
      const apiURI = this.menu.exePostOSClmRes
      if (apiURI) {
        try {
          this.submitting = true
          const result = await this.$http.post(apiURI, bmgForms)
          if (result.data) {
            const { data } = result.data
            if (data.prevBchJobs && data.prevBchJobs.length > 0) {
              this.promptResubmit = true
              this.getBchJobDetails(data.prevBchJobs)
            }
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
      this.batchForm.skipValidate = false
    }
  }
}
</script>
